export const base_url: string | undefined = process.env.REACT_APP_API_URL;
export const front_url: string | undefined = process.env.REACT_APP_FRONT_URL;
export const stripe_key: string | undefined = process.env.REACT_APP_STRIPE_KEY;

export const steps: string[] = [
  "Registration Type",
  
  "Workshop Selection", // Desactivable
  "Additional Items",
  "Paper Selection", // Desactivable
  "Personal Data",
  "Membership",
  "Payment",
  "Confirmation",
];

export const dates: {
  [key: string]: { standard: number; student: number; single: number };
}[] = [
  { early: { standard: 700, student: 500, single: 500 } },
  { regular: { standard: 820, student: 620, single: 620 } },
  { late: { standard: 920, student: 730, single: 730 } },
];

export const deadlines: { [key: string]: string }[] = [
  { early: "August 19th" },
  { regular: "October 3rd" },
  { late: "October 24th" },
];
